export const BookCardStyle = {
    container: 'flex flex-col p-6 w-full h-auto bg-lightBlack relative rounded-[4px]',
    imageButton: 'flex pb-4 items-start flex justify-between',
    image: 'mt-4',
    text: 'flex flex-col h-40',
    lastChild: 'mt-auto',
}
